// extracted by mini-css-extract-plugin
export default {"wrapper":"mWfZ37DUh2n7Ql6YRvoe"};